"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = void 0;
const actions_1 = require("./by-property-id/actions");
const actions_2 = require("./create/actions");
const actions_3 = require("./delete/actions");
exports.actions = () => {
    return {
        create: actions_2.default(),
        delete: actions_3.default(),
        getByPropertyId: actions_1.default(),
    };
};
//# sourceMappingURL=actions.js.map